import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";
import { delay } from "./Utils";

const FinaliseSubmission = () => {
  const messageDefault = "Finalise and submit";
  const messageProcessing = "Processing...";
  const button = document.querySelector("[data-submission-finalise]");
  if (button) {
    button.addEventListener("click", (ev) => {
      ev.preventDefault();
      const data = new FormData();
      data.append("action", "finalise_submission");
      data.append("submission_id", ev.target.dataset.submissionFinaliseId);
      ev.target.textContent = messageProcessing;
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
          }
          delay(1000).then(() => {
            ev.target.textContent = messageDefault;
            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: null,
            });
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          ev.target.textContent = messageDefault;
          createToast({
            type: "error",
            message: "System Error",
            duration: 1000,
          });
        });
    });
  }
};

export { FinaliseSubmission };
